<template lang="pug">
  .table-responsive
    table#tbMovimientos.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th
            | #
          th 
            | Nombre
          th
            | Acciones
      tbody
        tr(v-for="(com, index) in comercios" :key="com.id")
          td.is-size-7
            a.button.is-black.is-rounded.is-small {{ index + 1 }}
          td.is-size-7
            span.tag.is-black {{ com.nombre }}
          td.is-size-7
            a.button.is-rounded.is-danger.is-small(@click="deleteComercio(com)")
              i.fas.fa-trash
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
  export default {
    name: 'TbComercios',
    props: {
      comercios: {
        type: Array,
        default: []
      },
      comercioSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        hayDatos: true,
        itemsSelected: {},
        isDisabled: true,
      }
    },
    watch: {
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      comercioSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.comercioSel)
      },
    },
    methods: {
      iniciarComponente () {

      },
      deleteComercio (comercio) {
        this.$emit('deleteComercio', comercio)
      },
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/comercios/Tb_Comercios.vue